import { cx } from '@linaria/core';
import { textTitle } from 'styles/typography';
import { genGradient } from 'components/EntityCard/utils';
import { defaultThumbnail } from './Thumbnail.styles';

interface ThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
  fallback?: string;
  src?: string;
  className?: string;
  children?: React.ReactNode;
}

const DEFAULT_GRADIENT_TEXT = 'clarifai';

export const Thumbnail: React.FC<ThumbnailProps> = ({ src, fallback = '', className, children, ...rest }) => {
  const displayText = !src ? fallback.charAt(0) : null;

  return (
    <div
      className={cx(textTitle, defaultThumbnail, className)}
      style={{ backgroundImage: src ? `url('${src}')` : genGradient(fallback || DEFAULT_GRADIENT_TEXT, 'diagonal') }}
      {...rest}
    >
      {children || displayText}
    </div>
  );
};
